/** Public tutor wallet UI. Off until acquiring is ready; set VITE_WALLET_PUBLIC_ENABLED=true to show. */
export const WALLET_PUBLIC_ENABLED =
  String(import.meta.env.VITE_WALLET_PUBLIC_ENABLED ?? '').toLowerCase() === 'true';
